import React,{useState} from 'react';
import { Children } from 'react';
import './inscrire.css';
import logo from '../../assets/SGN_04_25_2023_1682462832504.png'
import { useRef,useEffect } from 'react';
import {animated,useSpring} from 'react-spring'
import axios from 'axios';
import { UserConnnectStateContext } from '../context/userConnectState';
import { useContext } from "react"

function Inscrire(props){
  const makeRequestToGitHub = async (accessToken) => {
    const apiUrl = "https://api.github.com/user";
    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };

    try {
      const response = await axios.get(apiUrl, { headers });
      const userData = response.data;
      console.log(userData);
      window.localStorage.setItem('user','')
      // Faites quelque chose avec les données de l'utilisateur
    } catch (error) {
      console.error("Erreur lors de la requête à l'API GitHub:", error);
    }
  };
  const {switchIsLogin} = useContext(UserConnnectStateContext)
    useEffect(() => {
        const handleGithubLogin = async () => {
          const code = new URLSearchParams(window.location.search).get('code');
    
          if (code) {
            try {
              const response = await axios.post(
                'https://github.com/login/oauth/access_token',
                {
                  client_id: 'a57d3935baef2e77b4cb',
                  client_secret: 'e9f66f34a5cd7e4602ed318891ee486663b1c883',
                  code: code,
                },
                {
                  headers: {
                    Accept: 'application/json',
                  },
                }
              );
    
              const accessToken = response.data.access_token;
              // Utilisez l'access token pour effectuer des requêtes à l'API GitHub
                            console.log(accessToken)
              makeRequestToGitHub(accessToken)
                switchIsLogin()
                
            } catch (error) {
              console.error('Erreur lors de l\'obtention de l\'access token:', error);
            }
          }
        };
    
        handleGithubLogin();
      }, []);
    
      const handleLogin = () => {
        const clientId = 'a57d3935baef2e77b4cb';
        const redirectUri = encodeURIComponent('https://dash-app-seven.vercel.app/dashboard');
        window.location.href = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}`;
      };
const springs = useSpring({
        from: { x: -400,
            opacity :0 },
        to: { x: 0,
            opacity :1 },
      })
    
    const [authenUserPass,setAuthenUserPass ] = useState({
        user : '',
        name :'',
        prename :'',
        password : '',
        saveInfo : false
    })      
    let userEntry = useRef('')
    let nameEntry = useRef('')
    let prenameEntry = useRef('')
    let passwordEntry = useRef('')
    let passwordConfirmEntry = useRef('')
    let saveInfoEntry = useRef(true)

    function loginSubmit (e){
        e.preventDefault()
        const confirm = document.querySelector('.confirm')
        const alert = document.querySelector('.alertPassword')
        if (passwordEntry.current.value==passwordConfirmEntry.current.value){

            setAuthenUserPass({
                user : userEntry.current.value,
                password : passwordEntry.current.value,
                saveInfo : saveInfoEntry.current.checked,
                name : nameEntry.current.value,
                prename : prenameEntry.current.value
            })
            alert.style.display='none'
            confirm.style.border=' 1px solid white'
        }
        else{
            // alert(passwordEntry.current.value+' red ' +passwordConfirmEntry.current.value)
            
            confirm.style.border='1px solid red'
            alert.style.display='block'
        }
        
        }
    
        function creerCompte (){
        const menu = document.querySelector('.autreConnexion')
        const ins = document.querySelector('.formInscrire')
        const creerCompte = document.querySelector('.creerCompte')
        const p = document.querySelector('.p')
        // menu.style.transition='0.5s'
        p.style.display='none'
        menu.style.overflow='clip'
        menu.style.width="0";
        menu.style.opacity="0";
        // menu.style.height="0";
        setTimeout(() => {
            menu.style.display="none";
            ins.style.display='flex'
            ins.style.opacity='1'
            creerCompte.style.background='transparent'
            creerCompte.style.color='white'
            creerCompte.style.cursor='none'

        }, 800);

        
    }

    return  <animated.div style={{...springs}} className='dash-inscrire'>
        {(function dashApp(){
            return <img src={logo} alt="logo dash app" style={{width : '120px'}}></img>
            })()
        }
            <button className='creerCompte' onClick={creerCompte}>Créer votre Compte</button>
            <p className='p'>------------- Ou -------------</p>
            <div  className="autreConnexion">
                <button className='avecGoogle'>Connecter avec compte Google</button>
                <button className='avecGithub' onClick={handleLogin}>Connecter avec compte Github</button>
            </div>
            <form className='formInscrire' onSubmit={loginSubmit} >
                <div className='fieldForm' >
                    <label htmlFor='user'>Email</label>
                    <input type='text' placeholder='Email ou telephone' ref={userEntry} id='user'  name='user' className='fieldtext' required/>
                </div>
                <div className='fieldForm' >
                    <label htmlFor='nom'>Nom</label>
                    <input type='text' placeholder='Nom' ref={nameEntry} id='nom'  name='nom' className='fieldtext' required/>
                </div>
                <div className='fieldForm' >
                    <label htmlFor='prename'>Prenom</label>
                    <input type='text' placeholder='Prenom' ref={prenameEntry} id='prename'  name='prename' className='fieldtext' required/>
                </div>
                <div className='fieldForm' >
                    <label htmlFor='password'>Password</label>
                    <input type='password' placeholder='password' ref={passwordEntry} id='password' name='password' className='fieldtext' required/>
                </div>
                <div className="d">
                    <div className='fieldForm' >
                        <label htmlFor='confirmPassword'>Confirm Password</label>
                        <input type='password' placeholder='confirmPassword' ref={passwordConfirmEntry} id='confirmPassword' name='confirmPassword' className='fieldtext confirm' required/>
                    </div>
                    <p className='alertPassword'>mots des passes non correspondant</p>  
                </div>
                <div className='checkForm' >
                    <input type='checkbox' ref={saveInfoEntry} id='saveInfo'   name='saveInfo' className='checktext' />
                    <label htmlFor='saveInfo'>Enregistrer vos information</label>  
                </div>                
                    <div className='submitInscrire'>
                <button className='submitButtonInscrire' type='submit'>Connexion</button>
                    </div>
            </form>
            {}
            {/* {JSON.stringify(authenUserPass)} */}
  
        </animated.div>
    
}





  
 








  export default  Inscrire